;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import { SHARE_TOUR_ELIGIBLE_DASHBOARD_VIEW_NAMES } from "@/components/dashboards/share-tour-eligible-view-names";
import { isProtectedWorkspaceViewName } from "@/lib/constants/protected-workspace-views";

export function listShareTourEligibleDashboardViewNames(): string[] {
	return [...SHARE_TOUR_ELIGIBLE_DASHBOARD_VIEW_NAMES];
}

export function getWorkspacePathViewSegment({
	pathname,
	workspaceId,
}: {
	pathname: string;
	workspaceId: string;
}): string | null {
	const normalizedPathname = pathname.replace(/\/$/, "") || "/";
	const prefix = `/${workspaceId}/`;
	if (!normalizedPathname.toLowerCase().startsWith(prefix.toLowerCase())) {
		return null;
	}

	const remainder = normalizedPathname.slice(prefix.length);
	const rawSegment = remainder.split("/")[0] ?? "";
	if (!rawSegment) {
		return null;
	}

	try {
		return decodeURIComponent(rawSegment).toLowerCase();
	} catch {
		return rawSegment.toLowerCase();
	}
}

export function getActiveShareTourViewNames({
	activeViewNames,
}: {
	activeViewNames: string[];
}): string[] {
	const eligibleByLowerName = new Map(
		listShareTourEligibleDashboardViewNames().map((viewName) => [
			viewName.toLowerCase(),
			viewName,
		]),
	);

	const activeEligible: string[] = [];
	for (const viewName of activeViewNames) {
		const normalized = viewName.trim();
		if (!normalized || isProtectedWorkspaceViewName(normalized)) {
			continue;
		}

		const catalogName = eligibleByLowerName.get(normalized.toLowerCase());
		if (!catalogName) {
			continue;
		}

		activeEligible.push(catalogName);
	}

	return activeEligible;
}

export type ShareViewTourLaunchResolution =
	| { status: "start-here" }
	| { status: "navigate"; route: string }
	| { status: "unavailable" };

/**
 * Prefer the current page when it is an active shareable dashboard view.
 * Otherwise route to leasing if active, else the first active eligible view.
 * When none are active, the tour cannot start.
 */
export function resolveShareViewTourStartRoute({
	workspaceId,
	currentPathname,
	activeViewNames,
}: {
	workspaceId: string;
	currentPathname: string;
	activeViewNames: string[];
}): ShareViewTourLaunchResolution {
	const activeEligibleViews = getActiveShareTourViewNames({ activeViewNames });
	if (activeEligibleViews.length === 0) {
		return { status: "unavailable" };
	}

	const currentSegment = getWorkspacePathViewSegment({
		pathname: currentPathname,
		workspaceId,
	});
	if (
		currentSegment &&
		activeEligibleViews.some(
			(viewName) => viewName.toLowerCase() === currentSegment,
		)
	) {
		return { status: "start-here" };
	}

	const leasingView = activeEligibleViews.find(
		(viewName) => viewName.toLowerCase() === "leasing",
	);
	const targetView = leasingView ?? activeEligibleViews[0];

	return {
		route: `/${workspaceId}/${targetView.toLowerCase()}`,
		status: "navigate",
	};
}
